import { DEFAULT_CONTEXTS } from './use-niche-context-manager.consts'
import type { DefaultContext } from '../../types'

export const getDefaultContexts = (customDefaultContexts?: DefaultContext[]): DefaultContext[] =>
  customDefaultContexts ?? DEFAULT_CONTEXTS
